import * as React from 'react';
export const IcInstagram = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 7.38a4.62 4.62 0 100 9.24 4.62 4.62 0 000-9.24zM12 15a3 3 0 110-6 3 3 0 010 6zm9-6.71a6.809 6.809 0 00-.42-2.19 4.66 4.66 0 00-2.68-2.63 6.81 6.81 0 00-2.19-.42H8.29a6.81 6.81 0 00-2.19.42A4.66 4.66 0 003.47 6.1a6.81 6.81 0 00-.42 2.19v7.42a6.81 6.81 0 00.42 2.19 4.66 4.66 0 002.63 2.63c.699.276 1.439.435 2.19.47 1 0 1.27.05 3.71.05s2.75 0 3.71-.05a6.81 6.81 0 002.19-.42 4.66 4.66 0 002.63-2.63c.282-.715.44-1.472.47-2.24 0-1 .05-1.27.05-3.71S21 9.25 21 8.29zm-1.62 7.35a5.3 5.3 0 01-.38 1.67A3.058 3.058 0 0117.31 19c-.537.192-1.1.297-1.67.31-1 0-1.24.05-3.64.05-2.4 0-2.69 0-3.64-.05A5.302 5.302 0 016.69 19 3.06 3.06 0 015 17.31a5.3 5.3 0 01-.31-1.67V12 8.36A5.3 5.3 0 015 6.69 3.06 3.06 0 016.69 5a5.3 5.3 0 011.67-.31h7.28a5.3 5.3 0 011.67.31A3.06 3.06 0 0119 6.69c.192.536.297 1.1.31 1.67 0 1 .05 1.24.05 3.64 0 2.4.01 2.69-.03 3.64h.05zM16.8 6.12a1.08 1.08 0 100 2.16 1.08 1.08 0 000-2.16z'
      fill='currentColor'
    />
  </svg>
);
